<template>
  <v-flex>
    <v-card class="ma-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense :color="colorBarraFormulario" flat>
        <v-toolbar-title :dark="!dark">Reporte de Asignaciones por Trabajador</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-chip label class="mr-1" link :color="colorAccent1" @click="_abrirDialogEnvioReporte()">
          <span v-bind:style="{ color: 'white' }">
            Envio de Reporte
          </span>
        </v-chip>
      <!--  <v-chip label class="mr-1" link :color="colorAccent1" @click="_exportarExcel()">
          <span v-bind:style="{ color: 'white' }">
            Exportar a Excel
          </span>
        </v-chip> -->
      </v-toolbar>

      <v-card-text>
        <v-row v-if="mostrarbusqueda" class="mt-0" justify="start" dense>
          <v-col cols="4" align="start">
            <v-text-field class="mx-4" :dark="dark" clearable outlined v-model="busquedaDesde" autocomplete="off"
              label="Búsqueda por fecha desde" placeholder="AAAA-MM-DD"
              @keyup.enter="_getReporteAsignacionesPorTrabajador()" 
              :error-messages="errorDesde"
              @input="validateFechaDesde"
              hint="Formato: AAAA-MM-DD"
              persistent-hint
              maxlength="10"
              dense></v-text-field>
          </v-col>
          <v-col cols="4" align="start">
            <v-text-field class="mx-4" :dark="dark" clearable outlined v-model="busquedaHasta" autocomplete="off"
              label="Búsqueda por fecha hasta" placeholder="AAAA-MM-DD" 
              @keyup.enter="_getReporteAsignacionesPorTrabajador()"
              :error-messages="errorHasta"
              @input="validateFechaHasta"
              hint="Formato: AAAA-MM-DD"
              persistent-hint
              maxlength="10"
              dense></v-text-field>
          </v-col>
          
        </v-row>
      </v-card-text>
    </v-card>

    <v-row v-if="loading">
      <v-spacer />
      <v-row class="mt-12">
        <v-col class="mt-12">
          <v-progress-linear class="mt-12 mb-12" :color="colorAccent1" indeterminate width="200px" rounded
            height="6"></v-progress-linear>
        </v-col>
      </v-row>
      <v-spacer />
    </v-row>

    <v-card v-if="!loading" class="ma-2" color="rgb(250, 250, 250, 1)">
      <v-toolbar :dark="!dark" dense :color="colorBarraFormulario" flat>
        <v-toolbar-title :dark="!dark">Estadistica de expedientes asignados</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
       
      </v-toolbar>
      <v-card-text>
        <v-row v-if="reporteAsignacionesPorTrabajador && reporteAsignacionesPorTrabajador.length > 0" class="mt-2" justify="center" dense>
          <v-col cols="12">
            <v-card class="pa-4">
              <h2 class="mb-4 text-center">Expedientes Presupuestados</h2>
              <v-row>
                <v-col cols="12" md="6" class="d-flex justify-center align-center">
                  <canvas ref="pieChartPresupuestadas" width="400" height="400"></canvas>
                </v-col>
                <v-col cols="12" md="6" class="d-flex align-center">
                  <div ref="leyendaContainerPresupuestadas" style="width: 100%;"></div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="reporteAsignacionesPorTrabajador && reporteAsignacionesPorTrabajador.length > 0" class="mt-2" justify="center" dense>
          <v-col cols="12">
            <v-card class="pa-4">
              <h2 class="mb-4 text-center">Expedientes En Proceso</h2>
              <v-row>
                <v-col cols="12" md="6" class="d-flex justify-center align-center">
                  <canvas ref="pieChartEnProceso" width="400" height="400"></canvas>
                </v-col>
                <v-col cols="12" md="6" class="d-flex align-center">
                  <div ref="leyendaContainerEnProceso" style="width: 100%;"></div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="reporteAsignacionesPorTrabajador && reporteAsignacionesPorTrabajador.length > 0" class="mt-2" justify="center" dense>
          <v-col cols="12">
            <v-card class="pa-4">
              <h2 class="mb-4 text-center">Expedientes Confirmados</h2>
              <v-row>
                <v-col cols="12" md="6" class="d-flex justify-center align-center">
                  <canvas ref="pieChartConfirmadas" width="400" height="400"></canvas>
                </v-col>
                <v-col cols="12" md="6" class="d-flex align-center">
                  <div ref="leyendaContainerConfirmadas" style="width: 100%;"></div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
         
        <v-row v-if="reporteAsignacionesPorTrabajador && reporteAsignacionesPorTrabajador.length > 0" class="mt-2" justify="start" dense>
          <v-col cols="12" >
            
            <v-data-table v-if="reporteAsignacionesPorTrabajador && reporteAsignacionesPorTrabajador.length > 0" locale="es" dense :headers="headers" hide-default-footer :items="reporteAsignacionesPorTrabajador"
              :items-per-page="-1"
              class="mt-2 elevation-1 alternating-rows bordered-table">
              <template v-slot:item.reservas_presupuestadas="{ item }">
                <div class="estado-cell text-center font-weight-bold"
                  :class="_getEstadoCellClass('PRESUPUESTADA', item.reservas_presupuestadas)"
                  :style="_getEstadoCellStyle('PRESUPUESTADA', item.reservas_presupuestadas)">
                  {{ item.reservas_presupuestadas || 0 }}
                </div>
              </template>

              <template v-slot:item.reservas_enproceso="{ item }">
                <div class="estado-cell text-center font-weight-bold"
                  :class="_getEstadoCellClass('EN PROCESO', item.reservas_enproceso)"
                  :style="_getEstadoCellStyle('EN PROCESO', item.reservas_enproceso)">
                  {{ item.reservas_enproceso || 0 }}
                </div>
              </template>

              <template v-slot:item.reservas_confirmadas="{ item }">
                <div class="estado-cell text-center font-weight-bold"
                  :class="_getEstadoCellClass('CONFIRMADA', item.reservas_confirmadas)"
                  :style="_getEstadoCellStyle('CONFIRMADA', item.reservas_confirmadas)">
                  {{ item.reservas_confirmadas || 0 }}
                </div>
              </template>

              <template v-slot:item.actions="{ item }">
                <div class="text-center">
                  <v-btn icon small :color="colorAccent1" @click="_verDetalleTrabajador(item)"
                    :disabled="!_getTrabajadorId(item) || loadingDetalleTrabajador">
                    <v-icon small>mdi-eye</v-icon>
                  </v-btn>
                </div>
              </template>

              <template v-slot:no-data>
                No hay datos disponibles
              </template>
              <template v-slot:body.append>
                <tr class="font-weight-bold" style="background-color: #e3f2fd;">
                  <td colspan="3" class="text-left">TOTALES</td>
                  <td class="text-center font-weight-bold"
                    :class="_getEstadoCellClass('PRESUPUESTADA', totales.reservas_presupuestadas)"
                    :style="_getEstadoCellStyle('PRESUPUESTADA', totales.reservas_presupuestadas)">{{ totales.reservas_presupuestadas }}</td>
                  <td class="text-center font-weight-bold"
                    :class="_getEstadoCellClass('EN PROCESO', totales.reservas_enproceso)"
                    :style="_getEstadoCellStyle('EN PROCESO', totales.reservas_enproceso)">{{ totales.reservas_enproceso }}</td>
                  <td class="text-center font-weight-bold"
                    :class="_getEstadoCellClass('CONFIRMADA', totales.reservas_confirmadas)"
                    :style="_getEstadoCellStyle('CONFIRMADA', totales.reservas_confirmadas)">{{ totales.reservas_confirmadas }}</td>
                  <td class="text-center">{{ totales.reservas_asignadas }}</td>
                  <td></td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <v-dialog v-model="showDialogDetalleTrabajador" max-width="1400px" persistent>
          <v-card color="rgb(250, 250, 250)">
            <v-toolbar dense :color="colorBarraFormulario" flat :dark="!dark">
              <v-toolbar-title>
                Detalle de reservas asignadas{{ trabajadorDetalleNombre ? ` - ${trabajadorDetalleNombre}` : '' }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon @click="_cerrarDialogDetalleTrabajador()">mdi-close-circle</v-icon>
            </v-toolbar>

            <v-card-text>
              <v-row v-if="loadingDetalleTrabajador" justify="center" class="py-8">
                <v-progress-circular indeterminate :color="colorAccent1"></v-progress-circular>
              </v-row>

              <v-data-table
                v-else
                locale="es"
                dense
                hide-default-footer
                :headers="headersDetalleTrabajador"
                :items="reporteReservasAsignadasTrabajador"
                :items-per-page="-1"
                class="mt-4 elevation-1 alternating-rows bordered-table"
              >
                <template v-slot:item.codigo="{ item }">
                  <a :href="_getPresupuestoDetalleHref(item.reserva_id)" class="detalle-link" target="_blank" rel="noopener noreferrer">
                    {{ item.codigo || "-" }}
                  </a>
                </template>

                <template v-slot:item.codigo_reserva="{ item }">
                  <a :href="_getPresupuestoDetalleHref(item.reserva_id)" class="detalle-link" target="_blank" rel="noopener noreferrer">
                    {{ item.codigo_reserva || "-" }}
                  </a>
                </template>

                <template v-slot:item.cliente_nombre="{ item }">
                  <div class="estado-cell font-weight-bold" :style="_getClienteDetalleStyle(item)">
                    {{ item.cliente_nombre || "-" }}
                  </div>
                </template>

                <template v-slot:item.fecha_creacion="{ item }">
                  {{ _formatearFechaHora(item.fecha_creacion) }}
                </template>

                <template v-slot:item.fecha_asignacion="{ item }">
                  {{ _formatearFechaHora(item.fecha_asignacion) }}
                </template>

                <template v-slot:item.tiempo_asignacion="{ item }">
                  <v-tooltip bottom v-if="item.fecha_asignacion">
                    <template v-slot:activator="{ on, attrs }">
                      <div
                        class="estado-cell font-weight-bold text-center"
                        :style="_getAvisoTiempoAsignacionStyle(item)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        {{ item.tiempo_asignacion || "-" }}
                      </div>
                    </template>
                    <span>{{ _formatearFechaHora(item.fecha_asignacion) }}</span>
                  </v-tooltip>
                  <div v-else class="text-center">-</div>
                </template>

                <template v-slot:item.fecha_confirmacion="{ item }">
                  {{ _formatearFechaHora(item.fecha_confirmacion) }}
                </template>

                <template v-slot:item.tiempo_total_de_procesamiento="{ item }">
                  <v-tooltip bottom v-if="item.fecha_confirmacion">
                    <template v-slot:activator="{ on, attrs }">
                      <div class="estado-cell font-weight-bold text-center" v-bind="attrs" v-on="on">
                        {{ item.tiempo_total_de_procesamiento || "-" }}
                      </div>
                    </template>
                    <span>{{ _formatearFechaHora(item.fecha_confirmacion) }}</span>
                  </v-tooltip>
                  <div v-else class="text-center">{{ item.tiempo_total_de_procesamiento || "-" }}</div>
                </template>

                <template v-slot:no-data>
                  No hay reservas asignadas para mostrar
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="showDialogEnvioReporte" max-width="700px" persistent>
          <v-card color="rgb(250, 250, 250)">
            <v-toolbar dense :color="colorBarraFormulario" flat :dark="!dark">
              <v-toolbar-title>Envio de Reporte</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon @click="_cerrarDialogEnvioReporte()">mdi-close-circle</v-icon>
            </v-toolbar>

            <v-card-text>
              <v-alert v-if="mensajeEnvioReporte" type="success" dense text class="mt-4 mb-0">
                {{ mensajeEnvioReporte }}
              </v-alert>

              <v-alert v-if="errorEnvioReporte" type="error" dense text class="mt-4 mb-0">
                {{ errorEnvioReporte }}
              </v-alert>

              <v-row class="mt-4" dense>
                <v-col cols="12">
                  <v-text-field
                    v-model="emailEnvioReporte"
                    label="Correo"
                    outlined
                    dense
                    autocomplete="off"
                    :error-messages="errorEmailEnvioReporte"
                    @keyup.enter="_enviarReportePorTrabajadores"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row justify="end" class="mt-2">
                <v-chip
                  label
                  class="mr-1 px-8"
                  :color="colorAccent1"
                  text-color="white"
                  link
                  :disabled="loadingEnvioReporte"
                  @click="_enviarReportePorTrabajadores"
                >
                  <span v-if="loadingEnvioReporte" v-bind:style="{ color: 'white' }">Enviando...</span>
                  <span v-else v-bind:style="{ color: 'white' }">Enviar</span>
                </v-chip>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>

        
      </v-card-text>
    </v-card>

  </v-flex>
</template>

<script>
import { mapState, mapActions } from "vuex";
import * as XLSX from 'xlsx';

export default {
  data: () => ({
    mostrarbusqueda: true,
    busquedaDesde: "",
    busquedaHasta: "",
    errorDesde: "",
    errorHasta: "",
    showDialogEnvioReporte: false,
    loadingEnvioReporte: false,
    emailEnvioReporte: "",
    errorEmailEnvioReporte: "",
    mensajeEnvioReporte: "",
    errorEnvioReporte: "",
    showDialogDetalleTrabajador: false,
    loadingDetalleTrabajador: false,
    trabajadorDetalleNombre: "",
    

    headers: [
      {
        text: "TRABAJADOR",
        align: "left",
        sortable: false,
        value: "nombre",
      },
      {
        text: "INICIAL",
        align: "left",
        sortable: false,
        value: "inicial",
        width: "150px"
      },
      {
        text: "EMAIL",
        align: "left",
        sortable: false,
        value: "email",
      },
      
      
      {
        text: "PRESUPUESTOS",
        align: "center",
        sortable: false,
        value: "reservas_presupuestadas",
        width: "180px"
      },
      {
        text: "RESERVAS EN PROCESO",
        align: "center",
        sortable: false,
        value: "reservas_enproceso",
        width: "180px"
      },
      {
        text: "RESERVAS CONFIRMADAS",
        align: "center",
        sortable: false,
        value: "reservas_confirmadas",
        width: "180px"
      },
      {
        text: "RESERVAS ASIGNADAS",
        align: "center",
        sortable: false,
        value: "reservas_asignadas",
        width: "180px"
      },
      {
        text: "",
        align: "center",
        sortable: false,
        value: "actions",
        width: "70px"
      },
    ],

    headersDetalleTrabajador: [
      { text: "CODIGO", align: "left", sortable: false, value: "codigo", width: "150px" },
      { text: "COD. RESERVA", align: "left", sortable: false, value: "codigo_reserva", width: "150px" },
      { text: "CLIENTE", align: "left", sortable: false, value: "cliente_nombre", width: "240px" },
      { text: "FECHA CREACION", align: "left", sortable: false, value: "fecha_creacion", width: "170px" },
      { text: "FECHA ASIGNACION", align: "left", sortable: false, value: "fecha_asignacion", width: "170px" },
      { text: "TIEMPO ASIGNACION", align: "center", sortable: false, value: "tiempo_asignacion", width: "180px" },
      { text: "FECHA CONFIRMACION", align: "left", sortable: false, value: "fecha_confirmacion", width: "170px" },
      { text: "TIEMPO HASTA CONFIRMACION", align: "center", sortable: false, value: "tiempo_total_de_procesamiento", width: "210px" },
    ],

    
  }),

  computed: {
    ...mapState([
      "loading",
      "drawer",
      "dark",

      "colorAccent1",
      "colorAccent3",
      "colorBarraFormulario",


      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
      "colorBarraFormulario",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),

    ...mapState("estados", ["estados"]),

    ...mapState("reportes", ["reporteAsignacionesPorTrabajador", "reporteReservasAsignadasTrabajador"]),

    totales() {
      if (!this.reporteAsignacionesPorTrabajador || !this.reporteAsignacionesPorTrabajador.length > 0) {
        return {
          reservas_asignadas: 0,
          reservas_presupuestadas: 0,
          reservas_enproceso: 0,
          reservas_confirmadas: 0,
        };
      }
      
      return this.reporteAsignacionesPorTrabajador.reduce((acc, item) => {
        acc.reservas_asignadas += Number.parseInt(item.reservas_asignadas) || 0;
        acc.reservas_presupuestadas += Number.parseInt(item.reservas_presupuestadas) || 0;
        acc.reservas_enproceso += Number.parseInt(item.reservas_enproceso) || 0;
        acc.reservas_confirmadas += Number.parseInt(item.reservas_confirmadas) || 0;
        return acc;
      }, {
        reservas_asignadas: 0,
        reservas_presupuestadas: 0,
        reservas_enproceso: 0,
        reservas_confirmadas: 0,
      });
    },
  },

  watch: {
    'reporteAsignacionesPorTrabajador': {
      handler() {
        this.$nextTick(() => {
          this.dibujarGraficaPastelPresupuestadas();
          this.dibujarGraficaPastelEnProceso();
          this.dibujarGraficaPastelConfirmadas();
        });
      },
      deep: true
    },
  },
  
  mounted() {
    this._getReporteAsignacionesPorTrabajador();
  },

  methods: {
    ...mapActions("reportes", ["getReporteAsignacionesPorTrabajador", "getReporteReservasAsignadasTrabajador", "enviarReportePorTrabajadores"]),

    _abrirDialogEnvioReporte() {
      this.showDialogEnvioReporte = true;
      this.emailEnvioReporte = this.user?.email || "";
      this.errorEmailEnvioReporte = "";
      this.mensajeEnvioReporte = "";
      this.errorEnvioReporte = "";
    },

    _cerrarDialogEnvioReporte() {
      this.showDialogEnvioReporte = false;
      this.loadingEnvioReporte = false;
      this.errorEmailEnvioReporte = "";
      this.mensajeEnvioReporte = "";
      this.errorEnvioReporte = "";
    },

    _validarEmailEnvioReporte() {
      this.errorEmailEnvioReporte = "";
      const email = String(this.emailEnvioReporte || "").trim();
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!email) {
        this.errorEmailEnvioReporte = "El correo es obligatorio";
        return false;
      }
      if (!regex.test(email)) {
        this.errorEmailEnvioReporte = "Introduce un correo valido";
        return false;
      }
      return true;
    },

    async _enviarReportePorTrabajadores() {
      this.mensajeEnvioReporte = "";
      this.errorEnvioReporte = "";
      if (!this._validarEmailEnvioReporte() || this.loadingEnvioReporte) {
        return;
      }

      this.loadingEnvioReporte = true;
      try {
        const res = await this.enviarReportePorTrabajadores([this.access_token, this.emailEnvioReporte.trim()]);
        if (res?.success) {
          this.mensajeEnvioReporte = res.message || "Reporte enviado correctamente.";
        } else {
          this.errorEnvioReporte = res?.message || "No se pudo enviar el reporte.";
        }
      } catch (e) {
        this.errorEnvioReporte = "Error al enviar el reporte.";
      } finally {
        this.loadingEnvioReporte = false;
      }
    },

    _getTrabajadorId(item) {
      return item?.trabajador_id || item?.id || item?.user_id || null;
    },

    async _verDetalleTrabajador(item) {
      const trabajadorId = this._getTrabajadorId(item);
      if (!trabajadorId || this.loadingDetalleTrabajador) {
        return;
      }

      this.loadingDetalleTrabajador = true;
      this.trabajadorDetalleNombre = item?.nombre || "";
      this.showDialogDetalleTrabajador = true;

      try {
        await this.getReporteReservasAsignadasTrabajador([this.access_token, trabajadorId]);
      } finally {
        this.loadingDetalleTrabajador = false;
      }
    },

    _cerrarDialogDetalleTrabajador() {
      this.showDialogDetalleTrabajador = false;
      this.trabajadorDetalleNombre = "";
    },

    _getPresupuestoDetalleHref(reservaId) {
      if (!reservaId) {
        return "#";
      }
      return this.$router.resolve(`/Presupuestos/${reservaId}`).href;
    },

    _formatearFechaHora(valor) {
      if (!valor) {
        return "-";
      }

      if (typeof valor === "string") {
        const limpio = valor.trim();
        const match = limpio.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
        if (match) {
          const [, anio, mes, dia, hora, minuto] = match;
          return `${dia}/${mes}/${anio} ${hora}:${minuto}`;
        }
      }

      const fecha = new Date(valor);
      if (Number.isNaN(fecha.getTime())) {
        return valor;
      }

      const dia = String(fecha.getDate()).padStart(2, "0");
      const mes = String(fecha.getMonth() + 1).padStart(2, "0");
      const anio = fecha.getFullYear();
      const hora = String(fecha.getHours()).padStart(2, "0");
      const minuto = String(fecha.getMinutes()).padStart(2, "0");
      return `${dia}/${mes}/${anio} ${hora}:${minuto}`;
    },

    _getClienteDetalleStyle(item) {
      const color = item?.estado_color;
      if (!color) {
        return {};
      }
      return {
        backgroundColor: color,
        color: this._getTextColorForBackground(color),
      };
    },

    _getAvisoTiempoAsignacionStyle(item) {
      const aviso = String(item?.aviso || "").trim().toLowerCase();
      if (aviso === "urgente") {
        return {
          backgroundColor: "#ef4444",
          color: "#ffffff",
        };
      }
      if (aviso === "warninn" || aviso === "warning") {
        return {
          backgroundColor: "#f59e0b",
          color: "#ffffff",
        };
      }
      return {};
    },

    dibujarGraficaPastelPresupuestadas() {
      this._dibujarGraficaPastelPorCampo(
        "pieChartPresupuestadas",
        "leyendaContainerPresupuestadas",
        item => Number.parseInt(item.reservas_presupuestadas) || 0
      );
    },

    dibujarGraficaPastelEnProceso() {
      this._dibujarGraficaPastelPorCampo(
        "pieChartEnProceso",
        "leyendaContainerEnProceso",
        item => Number.parseInt(item.reservas_enproceso) || 0
      );
    },

    dibujarGraficaPastelConfirmadas() {
      this._dibujarGraficaPastelPorCampo(
        "pieChartConfirmadas",
        "leyendaContainerConfirmadas",
        item => Number.parseInt(item.reservas_confirmadas) || 0
      );
    },

    _dibujarGraficaPastelPorCampo(canvasRef, leyendaRef, getValue) {
      if (!this.reporteAsignacionesPorTrabajador || !this.reporteAsignacionesPorTrabajador.length > 0 || !this.$refs[canvasRef]) {
        if (this.$refs[leyendaRef]) {
          this.$refs[leyendaRef].innerHTML = '';
        }
        return;
      }

      const canvas = this.$refs[canvasRef];
      const ctx = canvas.getContext('2d');
      const centerX = canvas.width / 2;
      const centerY = canvas.height / 2;
      const radius = Math.min(centerX, centerY) - 40;

      const datos = this.reporteAsignacionesPorTrabajador.map(item => ({
        label: item.nombre,
        value: getValue(item),
      }));

      const datosConValor = datos.filter(d => d.value > 0);

      if (datosConValor.length === 0) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.font = '16px Arial';
        ctx.fillStyle = '#666';
        ctx.textAlign = 'center';
        ctx.fillText('No hay datos para mostrar', centerX, centerY);
        if (this.$refs[leyendaRef]) {
          this.$refs[leyendaRef].innerHTML = '';
        }
        return;
      }

      const total = datosConValor.reduce((sum, d) => sum + d.value, 0);
      const colores = [
        '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF',
        '#FF9F40', '#FF6384', '#C9CBCF', '#4BC0C0', '#FF9F40',
        '#FFCD56', '#36A2EB', '#9966FF', '#FF6384', '#4BC0C0'
      ];

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      let startAngle = -Math.PI / 2;

      datosConValor.forEach((dato, index) => {
        const sliceAngle = (dato.value / total) * 2 * Math.PI;
        const endAngle = startAngle + sliceAngle;

        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        ctx.arc(centerX, centerY, radius, startAngle, endAngle);
        ctx.closePath();
        ctx.fillStyle = colores[index % colores.length];
        ctx.fill();

        ctx.strokeStyle = '#fff';
        ctx.lineWidth = 2;
        ctx.stroke();

        const percentage = ((dato.value / total) * 100).toFixed(1);
        if (percentage > 5) {
          const midAngle = startAngle + sliceAngle / 2;
          const textX = centerX + (radius * 0.7) * Math.cos(midAngle);
          const textY = centerY + (radius * 0.7) * Math.sin(midAngle);

          ctx.fillStyle = '#fff';
          ctx.font = 'bold 16px Arial';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(`${percentage}%`, textX, textY);
        }

        startAngle = endAngle;
      });

      if (this.$refs[leyendaRef]) {
        let leyendaHTML = '<div style="display: flex; flex-direction: column; gap: 12px; padding: 10px; max-height: 400px; overflow-y: auto;">';

        datosConValor.forEach((dato, index) => {
          const percentage = ((dato.value / total) * 100).toFixed(1);
          const color = colores[index % colores.length];

          leyendaHTML += `
            <div style="display: flex; align-items: center; padding: 8px; background-color: #f5f5f5; border-radius: 4px;">
              <div style="width: 24px; height: 24px; background-color: ${color}; border: 2px solid #333; margin-right: 12px; flex-shrink: 0; border-radius: 3px;"></div>
              <span style="font-size: 14px; color: #333; line-height: 1.4;">
                <strong>${dato.label}</strong><br>
                <span style="color: #666;">${dato.value} reservas (${percentage}%)</span>
              </span>
            </div>
          `;
        });

        leyendaHTML += '</div>';
        this.$refs[leyendaRef].innerHTML = leyendaHTML;
      }
    },

    rowClass(item, index) {
      return index % 2 === 0 ? 'light-blue-row' : '';
    },

    _getEstadoColor(estadoNombre) {
      const fallbackByEstado = {
        "PRESUPUESTADA": "#90D5FF",
        "EN PROCESO": "#FFB5C0",
        "CONFIRMADA": "#ADEBB3",
      };
      const fallbackColor = fallbackByEstado[estadoNombre] || "#90a4ae";

      if (!Array.isArray(this.estados) || this.estados.length === 0) {
        return fallbackColor;
      }

      const estadoEncontrado = this.estados.find(e =>
        String(e && e.estado ? e.estado : "").trim().toUpperCase() === estadoNombre
      );

      return estadoEncontrado && estadoEncontrado.color ? estadoEncontrado.color : fallbackColor;
    },

    _isHexOrRgbColor(color) {
      if (!color) {
        return false;
      }
      const value = String(color).trim().toLowerCase();
      return value.startsWith("#") || value.startsWith("rgb");
    },

    _getTextColorForBackground(color) {
      const value = String(color || "").trim().toLowerCase();
      if (value.startsWith("#")) {
        let hex = value.replace("#", "");
        if (hex.length === 3) {
          hex = hex.split("").map(c => c + c).join("");
        }
        const r = parseInt(hex.substring(0, 2), 16) || 0;
        const g = parseInt(hex.substring(2, 4), 16) || 0;
        const b = parseInt(hex.substring(4, 6), 16) || 0;
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return luminance > 0.6 ? "#1f2937" : "#ffffff";
      }

      if (value.startsWith("rgb")) {
        const numbers = value.match(/\d+/g) || [];
        const r = parseInt(numbers[0], 10) || 0;
        const g = parseInt(numbers[1], 10) || 0;
        const b = parseInt(numbers[2], 10) || 0;
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return luminance > 0.6 ? "#1f2937" : "#ffffff";
      }

      return "#ffffff";
    },

    _debePintarEstadoCell(valor) {
      return (Number.parseInt(valor, 10) || 0) > 0;
    },

    _getEstadoCellClass(estadoNombre, valor) {
      if (!this._debePintarEstadoCell(valor)) {
        return "";
      }
      const color = this._getEstadoColor(estadoNombre);
      if (this._isHexOrRgbColor(color)) {
        return "";
      }
      return `${color} white--text`;
    },

    _getEstadoCellStyle(estadoNombre, valor) {
      if (!this._debePintarEstadoCell(valor)) {
        return {};
      }
      const color = this._getEstadoColor(estadoNombre);
      if (!this._isHexOrRgbColor(color)) {
        return {};
      }
      return {
        backgroundColor: color,
        color: this._getTextColorForBackground(color),
      };
    },

    _exportarExcel() {
      if (!this.reporteAsignacionesPorTrabajador || !this.reporteAsignacionesPorTrabajador.reservas_asignadas) {
        return;
      }

      // Crear el libro de trabajo
      const wb = XLSX.utils.book_new();

      // ===== SHEET 1: Reporte por Camino =====
      const datosPorTrabajador = this.reporteAsignacionesPorTrabajador.map(item => ({
        'TRABAJADOR': item.trabajador_nombre || '',
        'RESERVAS ASIGNADAS': item.reservas_asignadas || 0,
      }));

      // Agregar fila de totales
      datosPorTrabajador.push({
        'TRABAJADOR': 'TOTALES',
        'RESERVAS ASIGNADAS': this.totales.reservas_asignadas,
      });

      const wsPorTrabajador = XLSX.utils.json_to_sheet(datosPorTrabajador);
      XLSX.utils.book_append_sheet(wb, wsPorTrabajador, "Por Trabajador");

      

      // Generar nombre del archivo con la fecha actual
      const fecha = new Date().toISOString().split('T')[0];
      const nombreArchivo = `Reporte_Asignaciones_Por_Trabajador_${fecha}.xlsx`;

      // Descargar el archivo
      XLSX.writeFile(wb, nombreArchivo);
      
    },

    validateFechaDesde() {
      this.errorDesde = "";
      if (this.busquedaDesde && !this.isValidDateFormat(this.busquedaDesde)) {
        this.errorDesde = "El formato debe ser AAAA-MM-DD (ej: 2025-11-20)";
      }
    },

    validateFechaHasta() {
      this.errorHasta = "";
      if (this.busquedaHasta && !this.isValidDateFormat(this.busquedaHasta)) {
        this.errorHasta = "El formato debe ser AAAA-MM-DD (ej: 2025-11-20)";
      }
    },

    isValidDateFormat(dateString) {
      // Expresión regular para validar formato YYYY-MM-DD
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      
      if (!dateRegex.test(dateString)) {
        return false;
      }

      // Validar que sea una fecha válida
      const date = new Date(dateString);
      const [year, month, day] = dateString.split('-').map(Number);
      
      return date.getFullYear() === year && 
             date.getMonth() === month - 1 && 
             date.getDate() === day;
    },

    async _getReporteAsignacionesPorTrabajador() {
      // Validar fechas antes de buscar
      this.validateFechaDesde();
      this.validateFechaHasta();

      // Si hay errores, no continuar con la búsqueda
      if (this.errorDesde || this.errorHasta) {
        return;
      }

      const params = {};
      if (this.busquedaDesde != null && this.busquedaDesde != "") {
        params.fecha_desde = this.busquedaDesde;
      }
      if (this.busquedaHasta != null && this.busquedaHasta != "") {
        params.fecha_hasta = this.busquedaHasta;
      }
      await this.getReporteAsignacionesPorTrabajador([this.access_token, params]);
      console.log('reporteAsignacionesPorTrabajador', this.reporteAsignacionesPorTrabajador);
    },
    
  },
};
</script>

<style scoped>
.alternating-rows>>>tbody tr:nth-child(even) {
  background-color: #ebebeb !important;
}

.estado-cell {
  padding: 6px 8px;
  border-radius: 4px;
}

.detalle-link {
  color: #1565c0;
  font-weight: 600;
  text-decoration: none;
}

.detalle-link:hover {
  text-decoration: underline;
}

.bordered-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.bordered-table ::v-deep th {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep td {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep th:last-child,
.bordered-table ::v-deep td:last-child {
  border-right: none !important;
}

/* Si también quieres líneas horizontales entre las filas */
.bordered-table ::v-deep tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}

/* Si quieres un borde superior para la primera fila */
.bordered-table ::v-deep thead tr:first-child {
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
